import { render, staticRenderFns } from "./PhotoSlider.vue?vue&type=template&id=0fa808bd&"
import script from "./PhotoSlider.vue?vue&type=script&lang=js&"
export * from "./PhotoSlider.vue?vue&type=script&lang=js&"
import style0 from "./PhotoSlider.vue?vue&type=style&index=0&id=0fa808bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports